import * as React from "react";
import { createLink, LinkComponent } from "@tanstack/react-router";
import { ButtonProps } from "@mui/material";
import { ButtonBase } from "foundations/Button/ButtonBase";

const ButtonLink = React.forwardRef<
  HTMLAnchorElement,
  Omit<ButtonProps, "href">
>((props, ref) => {
  return <ButtonBase component={"a"} ref={ref} {...props} />;
});

const CreatedComponent = createLink(ButtonLink);

// @ts-expect-error - There is a type error with tanstack router but this works anyways
export const RouterMuiButton: LinkComponent<typeof ButtonLink> =
  React.forwardRef<HTMLAnchorElement, Omit<ButtonProps, "href">>(
    (props, ref) => {
      // @ts-expect-error - There is a type error with tanstack router but this works anyways
      return <CreatedComponent ref={ref} {...props} />;
    },
  );
